import { detect } from 'detect-browser';
import { UAParser } from 'ua-parser-js';

const browser = detect();
const { body } = document;
/**
 *
 */
function isMobileSafari() {
	return (
		navigator.userAgent.match( /(iPod|iPhone|iPad)/ ) &&
		navigator.userAgent.match( /AppleWebKit/ )
	);
}

switch ( browser && browser.name ) {
	case 'chrome':
		body.classList.add( 'is-chrome' );
		break;
	case 'firefox':
		body.classList.add( 'is-firefox' );
		break;
	case 'edge':
		body.classList.add( 'is-edge' );
		break;
	case 'safari':
		body.classList.add( 'is-safari' );
		break;
}

// This one is used on getUser() - themes/nesn-child/assets/js/frontend/dtc/index.js - L
function extractUserAgentInfo() {
	let osName = 'null';
	let osVersion = 'null';

	const parser = new UAParser( navigator.userAgent );
	const data = parser.getOS();

	if ( data ) {
		osName = data.name;
		osVersion = data.version;
	}

	window.localStorage.setItem( 'nesnOsVersion', osName + ' ' + osVersion );
};

extractUserAgentInfo();
isMobileSafari() ? body.classList.add( 'is-safari-mobile' ) : '';
